import BaseViewModel, { Required } from '@/infrastructure/BaseViewModel';

export default class Customer extends BaseViewModel {
    public Id: number = 0;
    @Required('Name cannot be null.')
    public Name: string = '';
    public Active: boolean = true;
    public Deleted: boolean = false;
    public DateCreated: Date = new Date();
    public DateUpdated: Date = new Date();
}
